import { useEffect } from "react";
import { applyAuthDarkTheme, clearAuthDarkTheme } from "./authTheme";

const useAuthDarkTheme = () => {
  useEffect(() => {
    applyAuthDarkTheme();

    return () => {
      clearAuthDarkTheme();
    };
  }, []);
};

export default useAuthDarkTheme;
